"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deposit = void 0;
var Deposit_1 = require("./Deposit");
Object.defineProperty(exports, "Deposit", { enumerable: true, get: function () { return __importDefault(Deposit_1).default; } });
